/**
 * @desc Directive that renders a vulnerability trend chart, showing open and closed
 * @example
 * // Large version w/swap functionality
 * <cs-vuln-trend-chart swap type="VULNERABILITY_REPORT_TYPE[key]" data="dataObj" range="rangeStr" height="450"></cs-vuln-trend-chart>
 * // Mini version w/o swap functionality, with padded width
 * <cs-vuln-trend-chart mini padded-width="90" type="VULNERABILITY_REPORT_TYPE[key]" data="dataObj" range="rangeStr" height="200"></cs-vuln-trend-chart>
 */
;(function () {
  'use strict'

  angular
    .module('contrast.vulnerabilities.trend')
    .directive('csVulnTrendChart', csVulnTrendChart)

  function csVulnTrendChart(
    $timeout,
    $translate,
    $compile,
    d3,
    dc,
    crossfilterService,
    csVulnTrendChartService,
    VULN_TREND_CHART_CONSTANTS,
    VULNERABILITY_REPORT_TYPE
  ) {
    'ngInject'

    var _customXAxisSelector = 'g.sub._0 .stack._0 .line'

    return {
      restrict: 'E',
      replace: true,
      scope: {
        type: '=',
        data: '=',
        height: '=',
        paddedWidth: '=',
        negativeOffset: '=',
        range: '='
      },
      controller: 'csVulnTrendChartCtrl',
      controllerAs: 'vulnTrendCtrl',
      templateUrl: 'components/vulnerabilities/cs-vuln-trend-chart.html',
      link: function ($scope, element, attrs, ctrl) {
        var _viewData
        var parent = element.parent()
        var rendering = false
        var preRender = false
        var renderers = 0
        var isSwapEnabled =
          attrs.hasOwnProperty('swap') && !angular.isUndefined(attrs.swap)
        var isMini =
          attrs.hasOwnProperty('mini') && !angular.isUndefined(attrs.mini)
        var innerContainerEl = element.find('.vuln-trend-chart-inner-container')
        if (isMini) {
          innerContainerEl.addClass('mini')
        }

        $scope.$watch(
          'data',
          function (newVal) {
            if (newVal && newVal.loaded) {
              _viewData = csVulnTrendChartService.buildViewData(
                $scope.data,
                $scope.range,
                isMini,
                $scope.type
              )
              ctrl.init($scope.type, _viewData)
              init()
            }
          },
          true
        )

        function init() {
          $scope.$watch(
            function () {
              return parent.width()
            },
            function (newValue, oldValue) {
              if (newValue && newValue != oldValue) {
                renderChart()
              }
            }
          )

          $scope.swap = function () {
            _viewData.order.reverse()
            _viewData.yAxisData.tickValues = _viewData.yAxisData.tickValues
              .reverse()
              .map(function (v) {
                if (v == 0) {
                  return 0
                }
                if (v > 0) {
                  return -Math.abs(v)
                }
                return Math.abs(v)
              })

            var tmp = _viewData.lineChartConfigs.shift()

            _viewData.lineChartConfigs = _viewData.lineChartConfigs.reverse()

            // Inverse counts
            angular.forEach(_viewData.order, function (key) {
              _viewData[key] = _viewData[key].map(function (o) {
                if (o.count < 0) {
                  o.count = Math.abs(o.count)
                } else {
                  o.count = -o.count
                }
                return o
              })
            })

            _viewData.lineChartConfigs.unshift(tmp)

            csVulnTrendChartService.calculateYRange(_viewData)

            renderChart(true)
          }

          _viewData.dotRadius = isMini
            ? VULN_TREND_CHART_CONSTANTS.DOT_RADIUS_MINI
            : VULN_TREND_CHART_CONSTANTS.DOT_RADIUS

          var chartEl = innerContainerEl.find(
            '.' + VULN_TREND_CHART_CONSTANTS.VULN_TREND_CHART
          )

          var chart = dc.compositeChart(chartEl[0]).renderTitle(false)

          innerContainerEl
            .find('.swap')
            .css({ display: isSwapEnabled ? 'block' : 'none' })

          renderChart()

          function renderChart(force) {
            var parentWidth = parent.width()

            if (!rendering || force) {
              rendering = true
              renderers++
              innerContainerEl.addClass(VULN_TREND_CHART_CONSTANTS.LOADING)
              parent.css({ height: $scope.height + 'px' })
              chartEl.css({ height: $scope.height + 'px' })

              // The timeout matches the CSS transition time
              $timeout(function () {
                var compose = []

                angular.forEach(
                  _viewData.lineChartConfigs,
                  function (lineChartConfig) {
                    var data
                    if (
                      lineChartConfig.which ===
                      VULN_TREND_CHART_CONSTANTS.CUSTOM_X_AXIS
                    ) {
                      data = lineChartConfig.data
                    } else {
                      data = _viewData[lineChartConfig.which]
                    }
                    var ndx = crossfilterService(data)
                    var dimension = ndx.dimension(function (d) {
                      return d.timestamp
                    })

                    var group = dimension
                      .group()
                      .order(function (p) {
                        return p
                      })
                      .reduceSum(function (d) {
                        return d.count
                      })

                    var lineChart = dc
                      .lineChart(chart)
                      .group(group)
                      .dotRadius(_viewData.dotRadius)
                      .renderArea(true)
                      .renderDataPoints({
                        radius: _viewData.dotRadius,
                        fillOpacity: 1,
                        strokeOpacity: 1
                      })
                      .clipPadding(0)

                    if (
                      lineChartConfig.which ===
                      VULN_TREND_CHART_CONSTANTS.CUSTOM_X_AXIS
                    ) {
                      lineChart.xyTipsOn(false)
                    }

                    compose.push(lineChart)
                  }
                )

                var paddedWidth = $scope.paddedWidth || 0
                var negativeOffset = $scope.negativeOffset || 0
                var width = parentWidth + paddedWidth - negativeOffset
                var xDomain = _viewData.xAxisData.domain
                chart
                  .width(width > 0 ? width : 0)
                  .height($scope.height)
                  .clipPadding(0)
                  .x(d3.time.scale().domain(xDomain))
                  .dimension(
                    crossfilterService(
                      _viewData[VULN_TREND_CHART_CONSTANTS.OPEN].concat(
                        _viewData[VULN_TREND_CHART_CONSTANTS.CLOSED]
                      )
                    ).dimension(function (d) {
                      return d.timestamp
                    })
                  )
                  .brushOn(false)
                  .compose(compose)
                  .y(
                    d3.scale
                      .linear()
                      .domain([
                        _viewData.yRange[0] +
                          VULN_TREND_CHART_CONSTANTS.Y_AXIS_MIN_PAD,
                        _viewData.yRange[1] +
                          VULN_TREND_CHART_CONSTANTS.Y_AXIS_MAX_PAD
                      ])
                  )

                var xAxisTickValues =
                  _viewData.xAxisData.tickValues || _viewData.xAxisData.values
                chart
                  .xAxis()
                  .tickFormat(_viewData.xAxisData.formatter)
                  .tickValues(xAxisTickValues)

                if (!isMini) {
                  var yAxisTickValues = _viewData.yAxisData.tickValues
                  chart
                    .yAxis()
                    .tickValues(yAxisTickValues)
                    .tickFormat(_viewData.yAxisData.formatter)
                } else {
                  chart.yAxis().tickFormat(function () {
                    return ''
                  })
                }

                var dotMap = {}

                chart.on('postRender', function () {
                  _customXAxis()
                  angular.forEach(_viewData.order, _manualStyles)

                  _groupDotCoords()
                  if (!isMini) {
                    _drawConnectorGroups()
                  }

                  _updateSwapIconPosition(
                    innerContainerEl,
                    chartEl,
                    element.find('.vuln-trend-chart-empty-state-msg')
                  )

                  if (preRender) {
                    $compile(chartEl)($scope)
                  }
                  preRender = false
                  rendering = false
                  renderers--

                  if (parentWidth != parent.width()) {
                    renderChart(true)
                  }

                  if (renderers == 0) {
                    innerContainerEl.removeClass(
                      VULN_TREND_CHART_CONSTANTS.LOADING
                    )
                    innerContainerEl
                      .find('.swap')
                      .css({ visibility: 'visible' })
                  }
                })

                function _customXAxis() {
                  chart
                    .select(_customXAxisSelector)
                    .classed(VULN_TREND_CHART_CONSTANTS.CUSTOM_X_AXIS, true)
                }

                function _manualStyles(key, index) {
                  _manualStylesPath(key, index)
                  _manualStylesDots(key, index)
                  _manualStylesGradient(key, index)
                }

                function _manualStylesPath(prefix, index) {
                  chart
                    .select('g.sub._' + (index + 1) + ' .stack._0 .line')
                    .classed(prefix + '-path', true)
                }

                function _manualStylesDots(key, index) {
                  chart
                    .selectAll(
                      'g.sub._' + (index + 1) + ' .dc-tooltip._0 > .dot'
                    )
                    .classed('mini', isMini)
                    .classed(key + '-dots', true)
                    .classed('hidden', function (obj) {
                      return obj.data.value === 0
                    })
                    .attr('cs-vuln-trend-chart-tooltip', function (o) {
                      return o.data.value ? '' : null
                    })
                    .attr(
                      'template',
                      "'" + VULN_TREND_CHART_CONSTANTS.TOOLTIP_TPL_DOT + "'"
                    )
                    .attr('count', function (o) {
                      return Math.abs(o.data.value)
                    })
                    .attr('timestamp', function (o) {
                      return o.data.key
                    })
                    .attr('display-position', 'right')
                    .attr('display-class', function () {
                      var className = VULN_TREND_CHART_CONSTANTS.CHART_TOOLTIP
                      if (key === VULN_TREND_CHART_CONSTANTS.CLOSED) {
                        className +=
                          ' ' + VULN_TREND_CHART_CONSTANTS.CLOSED_VULN
                      }
                      return className
                    })
                    .attr('status-breakdown', function (obj) {
                      var viewObj = _viewData.byTimestamp[key][obj.data.key]
                      return viewObj.statusBreakdown.map(function (o) {
                        return (
                          o.value +
                          VULN_TREND_CHART_CONSTANTS.DELIM +
                          o.viewName
                        )
                      })
                    })
                }

                function _manualStylesGradient(key, index) {
                  var id = 'areaLinearGradient_' + key
                  var defs = chart.select('defs')

                  var linearGradient = defs.append('linearGradient')
                  if (index === 0) {
                    linearGradient
                      .attr('id', id)
                      .attr('x1', '0')
                      .attr('y1', '1')
                      .attr('x2', '0')
                      .attr('y2', '0')
                  } else if (index === 1) {
                    linearGradient
                      .attr('id', id)
                      .attr('x1', '0')
                      .attr('y1', '0')
                      .attr('x2', '0')
                      .attr('y2', '1')
                  }

                  linearGradient
                    .append('stop')
                    .attr('offset', '0%')
                    .classed(key + '-gradient-start', true)

                  linearGradient
                    .append('stop')
                    .attr('offset', '100%')
                    .classed(key + '-gradient-end', true)

                  chart
                    .select('g.sub._' + (index + 1) + ' .stack._0 .area')
                    .attr('fill', 'url(#' + id + ')')
                }

                function _groupDotCoords() {
                  for (var i = 1; i <= 2; i++) {
                    chart
                      .selectAll('g.sub._' + i + ' .dc-tooltip._0 > .dot')
                      .attr('data', function (d) {
                        var el = angular.element(this)
                        var x = el.attr('cx')
                        _addDotXClass(el, x)
                        if (!dotMap[x]) {
                          dotMap[x] = []
                        }
                        dotMap[x].push({
                          el: el,
                          data: d
                        })
                        el.on('mouseenter', function () {
                          _mouseHandler.call(
                            this,
                            VULN_TREND_CHART_CONSTANTS.SHOW
                          )
                        })
                        el.on('mouseleave', function () {
                          _mouseHandler.call(
                            this,
                            VULN_TREND_CHART_CONSTANTS.HIDE
                          )
                        })
                        return false // don't actually apply the data attribute... might be a smarter way to do this...
                      })
                  }
                }

                function _mouseHandler(action) {
                  var el = angular.element(this)
                  _updateClassNameActive(el, action)
                }

                function _drawConnectorGroups() {
                  var transl = {
                    title_reports_netRemainder: $translate.instant(
                      'title_reports_netRemainder'
                    ),
                    title_reports_totalSum: $translate.instant(
                      'title_reports_totalSum'
                    )
                  }

                  var mainGroup = chart.select('g')
                  angular.forEach(dotMap, function (circleObjs, x) {
                    var yCoords = []
                    // var drawCircleFns = [];
                    angular.forEach(circleObjs, function (circleObj) {
                      yCoords.push(circleObj.el.attr('cy'))
                    })
                    if (yCoords[0] != yCoords[1]) {
                      var connectorGroup = mainGroup
                        .append('g')
                        .attr('transform', _buildTransformStr())
                        .classed(
                          VULN_TREND_CHART_CONSTANTS.CUSTOM_CONNECTOR,
                          true
                        )
                      var y1 = parseInt(yCoords[0])
                      var y2 = parseInt(yCoords[1])
                      if (circleObjs[0].data.data.value) {
                        y1 -= _viewData.dotRadius / 2 + 4
                      }
                      if (circleObjs[1].data.data.value) {
                        y2 += _viewData.dotRadius / 2 + 4
                      }

                      connectorGroup
                        .append('line')
                        .attr('x1', x)
                        .attr('y1', y1)
                        .attr('x2', x)
                        .attr('y2', y2)
                        .attr('stroke-width', 1)
                        .attr(
                          'stroke',
                          VULN_TREND_CHART_CONSTANTS.CONNECTOR_LINE_COLOR
                        )
                        .attr('shape-rendering', 'crispEdges')

                      // Make a transparent line that is used to create a wider mouse hover area
                      // This is also where we attach the connector info tooltip
                      var mouseHoverLine = connectorGroup
                        .append('rect')
                        .attr(
                          'x',
                          x -
                            VULN_TREND_CHART_CONSTANTS.HOVER_AREA_STROKE_WIDTH_NORMAL /
                              2
                        )
                        .attr('y', y2)
                        .attr(
                          'width',
                          VULN_TREND_CHART_CONSTANTS.HOVER_AREA_STROKE_WIDTH_NORMAL
                        )
                        .attr('height', y1 - y2)
                        .attr('stroke-width', 2)
                        .attr('fill', 'transparent')
                        .attr(
                          'template',
                          "'" +
                            VULN_TREND_CHART_CONSTANTS.TOOLTIP_TPL_CONNECTOR +
                            "'"
                        )
                        .attr('display-position', 'right')
                        .attr(
                          'display-class',
                          [
                            VULN_TREND_CHART_CONSTANTS.CHART_TOOLTIP,
                            VULN_TREND_CHART_CONSTANTS.CONNECTOR_INFO
                          ].join(' ')
                        )

                      if ($scope.type === VULNERABILITY_REPORT_TYPE.NEW) {
                        var newCount = _determineNewTooltipCount(circleObjs)
                        mouseHoverLine
                          .attr('cs-vuln-trend-chart-tooltip', true)
                          .attr('count', function () {
                            // Remove the negative if it exists, because we use a caret icon to indicate pos/neg
                            return Math.abs(newCount)
                          })
                          .attr('report-type', VULNERABILITY_REPORT_TYPE.NEW)
                          .attr('count-sign', function () {
                            if (newCount > 0) {
                              return 'positive'
                            } else if (newCount < 0) {
                              return 'negative'
                            }
                          })
                      } else if (
                        $scope.type === VULNERABILITY_REPORT_TYPE.TOTAL
                      ) {
                        mouseHoverLine
                          .attr('cs-vuln-trend-chart-tooltip', true)
                          .attr('count', function () {
                            return (
                              Math.abs(circleObjs[0].data.data.value) +
                              Math.abs(circleObjs[1].data.data.value)
                            )
                          })
                          .attr('report-type', VULNERABILITY_REPORT_TYPE.TOTAL)
                          .attr('text', transl.title_reports_totalSum)
                      }

                      var c = connectorGroup.attr('class')
                      connectorGroup.attr(
                        'class',
                        c +
                          ' ' +
                          VULN_TREND_CHART_CONSTANTS.GROUP_X_PREFIX +
                          Math.floor(x)
                      )
                    }
                  })
                }

                preRender = true
                chart.render()
              }, VULN_TREND_CHART_CONSTANTS.RENDER_DELAY)
            }
          }
        }
      }
    }

    function _buildTransformStr() {
      return (
        'translate(' +
        VULN_TREND_CHART_CONSTANTS.TRANSLATE_X +
        ',' +
        VULN_TREND_CHART_CONSTANTS.TRANSLATE_Y +
        ')'
      )
    }

    function _updateClassNameActive(el, action) {
      var className = el.attr('class')
      className =
        action === VULN_TREND_CHART_CONSTANTS.SHOW
          ? _addClassActive(className)
          : _removeClassActive(className)
      el.attr('class', className)
    }

    function _addClassActive(className) {
      if (className.indexOf(VULN_TREND_CHART_CONSTANTS.ACTIVE) === -1) {
        return className + ' ' + VULN_TREND_CHART_CONSTANTS.ACTIVE
      }
      return className
    }

    function _removeClassActive(className) {
      return className
        .split(' ')
        .filter(function (str) {
          return str !== VULN_TREND_CHART_CONSTANTS.ACTIVE
        })
        .join(' ')
    }

    function _addDotXClass(el, x) {
      var className = el.attr('class')
      if (className.indexOf(VULN_TREND_CHART_CONSTANTS.DOT_X_PREFIX) === -1) {
        el.attr(
          'class',
          className +
            ' ' +
            VULN_TREND_CHART_CONSTANTS.DOT_X_PREFIX +
            Math.floor(x)
        )
      }
    }

    function _updateSwapIconPosition(element, chartEl, emptyStateEl) {
      var y =
        _calculateSwapIconYPosition(chartEl, emptyStateEl) +
        VULN_TREND_CHART_CONSTANTS.SWAP_Y_OFFSET
      element.find('.swap i').css({ top: y + 'px' })
    }

    function _calculateSwapIconYPosition(chartEl, emptyStateEl) {
      var a = chartEl
        .find('path.' + VULN_TREND_CHART_CONSTANTS.CUSTOM_X_AXIS)[0]
        .getBoundingClientRect().top
      var b = emptyStateEl[0].getBoundingClientRect().top
      return a - b
    }

    // open is positive, closed is negative
    function _determineNewTooltipCount(circleObjs) {
      // determine whether a is open or closed from it's className
      var svgClassNameObj = circleObjs[0].el[0].className
      var isOpen =
        svgClassNameObj.animVal.indexOf('open') > -1 ||
        svgClassNameObj.baseVal.indexOf('open') > -1

      // Get absolute values for each count, since the negative was just for the view
      // probably would be better to have a viewCount so we don't have to do this...
      var a = Math.abs(circleObjs[0].data.data.value)
      var b = Math.abs(circleObjs[1].data.data.value)

      return isOpen ? a - b : b - a
    }
  }
})()
